module.exports = __webpack_public_path__ + "img/front_14.d7a70931.svg";